import React, { FC, useCallback, useMemo, MouseEvent } from 'react'

import {
  EditorState,
  RichUtils,
  ContentBlock,
} from 'draft-js'

import {
  getSelectedBlocksList,
} from 'draftjs-utils'

import {
  IconComponentType,
} from '../../types/app'

import {
  ITextEditor_EditorUpdate,
} from '@kaidam/fc-shared/src/types/texteditor'

import ToolbarButton from './ToolbarButton'

interface ToolbarButtonBlockProps {
  style: string,
  title: string,
  className?: string,
  icon: IconComponentType,
  editorState: EditorState,
  setEditorState: ITextEditor_EditorUpdate,
}

const ToolbarButtonBlock: FC<React.PropsWithChildren<ToolbarButtonBlockProps>> = ({
  style,
  title,
  className,
  icon,
  editorState,
  setEditorState,
}) => {

  const onClick = useCallback(() => {
    setEditorState(
      RichUtils.toggleBlockType(editorState, style)
    )
  }, [
    editorState,
  ])

  const active = useMemo<boolean>(() => {
    if(!editorState || !style) return false
    const blocks = getSelectedBlocksList(editorState) as ContentBlock[]
    const allTypes = blocks.reduce<Record<string, boolean>>((all, block) => {
      all[block.getType()] = true
      return all
    }, {})
    if(Object.keys(allTypes).length != 1) return false
    return allTypes[style] ? true : false
  }, [
    editorState,
    style,
  ])

  return (
    <ToolbarButton
      title={ title }
      className={ className }
      icon={ icon }
      active={ active }
      onClick={ onClick }
    />
  )
}

export default ToolbarButtonBlock